export default __webpack_public_path__ + "static/h1product_sp-501f9fada947429e497418be18e65cbd.png";